<template>
    <Page logoLink="console">
        <template #menu>
            <v-spacer></v-spacer>
            <v-menu offset-y tile class="black">
                <template #activator="{ on }">
                    <v-btn icon plain dark v-on="on">
                        <v-icon>mdi-account</v-icon>
                    </v-btn>
                </template>
                <v-list dense dark>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title style="font-size: 18px; font-weight: 500">
                                <template v-if="account.Email">{{account.Email}}</template>
                                <template v-else>demo</template>
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-btn icon :to="{name: 'logout'}" title="logout"><v-icon>mdi-logout-variant</v-icon></v-btn>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item link :to="{name: 'settings'}">
                        Personal settings
                    </v-list-item>
                </v-list>
            </v-menu>
        </template>

        <v-card class="ma-auto" max-width="800" elevation="0">
            <h2>
                Settings
                <v-progress-circular v-if="loading" color="green" indeterminate />
            </h2>
            <v-alert v-if="alert.msg" :color="alert.color" icon="mdi-alert-octagon-outline" outlined text dismissible>
                {{alert.msg}}
            </v-alert>
            <div class="d-flex align-center">
                <v-simple-checkbox v-model="settings.MuteEmailAlerts" @click="save()" color="green"/>
                Mute all email alerts
            </div>

            <v-btn :to="{name: 'console'}" block outlined class="mt-10" exact>
                <v-icon small>mdi-arrow-left-bold</v-icon>
                Back to console
            </v-btn>
        </v-card>
    </Page>
</template>

<script>
import Page from "@/pages/Page";

export default {
    components: {Page},
    props: {
        email: String,
    },

    data() {
        return {
            account: {},
            settings: {},
            loading: false,
            alert: {msg: '', color: ''},
        };
    },

    mounted() {
        this.getAccount();
        this.get();
    },

    methods: {
        getAccount() {
            this.$api.account((data) => {
                this.account = data;
            });
        },
        get() {
            this.loading = true;
            this.alert = {msg: '', color: ''};
            this.$api.accountSettings(null,(data, meta) => {
                this.loading = false;
                if (meta.code > 400) {
                    this.alert.msg = 'Failed to get settings, please try again later'
                    this.alert.color = 'red';
                }
                this.settings = data;
            });
        },
        save() {
            this.loading = true;
            this.alert = {msg: '', color: ''};
            this.$api.accountSettings(this.settings,(data, meta) => {
                this.loading = false;
                if (meta.code > 400) {
                    this.alert.msg = 'Failed to save settings, please try again later'
                    this.alert.color = 'red';
                } else {
                    this.alert.msg = 'Saved'
                    this.alert.color = 'green';
                }
                this.settings = data;
            });
        },
    },
};
</script>

<style scoped>

</style>
